import "./app.scss";
import "./js/index";
import { showCookieBarCustom } from "/core/static/core/libs/index.js";

window.showCookieBarCustom = showCookieBarCustom;

$(() => {
  if (window?.CONSENT_IS_GIVEN !== true) {
    const cookie = document.querySelector('.js-cookie');

    setTimeout(() => {
        cookie.classList.add('active');
    }, 3500);

    const cookieBtn = document.querySelectorAll('.js-cookie-btn');
    cookieBtn.forEach((item) => {
      item.addEventListener('click', () => {
        cookie.classList.remove('active');
      })
    });
  }
})

// const $formModal = $("section.js-modal");
const $successModal = $("section.js-modal-success");
const $formModal = $("section.js-short-form-modal");

function setError(form, field, error) {
const $div = form
  .find(`div.js-form-item input[name="${field}"]`)
  .parents("div.js-form-item");
$div.addClass("error-item");
$div.append(`<div class="error__tooltip"><span>${error}</span></div>`);
}

function removeErrors(form) {
const $elements = form.find(`div.js-form-item`);
$elements.removeClass("error-item");
for (let index = 0; index < $elements.length; index++) {
  const $element = $($elements[index]);
  $element.find("input").removeClass("error");
  $element.find("div.error__tooltip").remove();
}
}



//   window[`reCaptchaonSubmit_${recaptchaWidgetId}`] = (data, widgetId) => {
//     let phone = $userForm.find(".js-select-phone").val() + mask.unmaskedValue;
//     let serialize = $userForm.serializeArray().map((item) => {
//       if (item.name === "phone_number") {
//         item.value = phone;
//       }
//       return item;
//     });

//   window[`reCaptchaonSubmit_${recaptchaWidgetId}`] = (data, widgetId) => {
//     let phone = $userForm.find(".js-select-phone").val() + mask.unmaskedValue;
//     let serialize = $userForm.serializeArray().map((item) => {
//       if (item.name === "phone_number") {
//         item.value = phone;
//       }
//       return item;
//     });

const $shortForm = $("form.short-user-request-form");
const shortRecaptchaWidgetId = $shortForm
.find(".recaptcha")
.data("widget-uuid");


$shortForm.on("submit", function (e) {
e.preventDefault()
const $currentForm = $(e.currentTarget)
const $shortSubmitButton = $currentForm.find('[type="submit"]');
let serialize = $currentForm.serializeArray()

$shortSubmitButton.addClass("form__submit--load");
$shortSubmitButton.prop("disabled", true);
removeErrors($shortForm);

$.ajax({
  url: $currentForm.attr("action"),
  method: "post",
  data: serialize,
})
  .done((res) => {
    if (res.status) {
      if (!$currentForm.hasClass('form-hero__form')) {
        $successModal.addClass("visible");
        setTimeout(() => {
          $successModal.addClass("active");
        }, 500);
      } else {
        const formHero = document.querySelector('.form-hero');
        formHero.classList.add('message');
      }

      $formModal.removeClass("feedback--visibl-modal")
      $shortForm
        .closest(".js-short-form")
        .removeClass("over transition active");
      $shortForm.trigger("reset");
      if (window.ANALYTICS_ENABLED == true) {
        (dataLayer = window.dataLayer || []).push({
          eCategory: "Form",
          eAction: "sent",
          eLabel: "",
          event: "GTMForms",
        });
      }

      const allShortClickFrom = document.querySelectorAll("#field_short_click_from");
      allShortClickFrom.forEach(item => {
        item.value = "";
      })

    } else {
      for (const [field, errors] of Object.entries(res.form_errors)) {
          setError($currentForm, field, errors[0]);
      }
    }
  })
  .fail((res) => {})
  .always(() => {
    $shortSubmitButton.prop("disabled", false);
    // grecaptcha.reset(widgetId);
    $shortSubmitButton.removeClass("form__submit--load");
  });
return false;
});
